


const uuid = require('uuid')
const vlaanderen = ['vlaanderen', 'mechelen', 'engie'].includes(process.env.VUE_APP_TENANT)

export const uuidValidateV4 = ({ id }) => {
  return uuid.validate(id) && uuid.version(id) === 4
}

export const isNumeric = (string) => /^\d+$/.test(string)
export const isFloat = value => parseFloat(value) === value
export const isFloatString = value => parseFloat(value)+'' === value
export const isString = (string) => (typeof string === 'string' || string instanceof String)
export const isObject = (item) => (item && typeof item === 'object' && !Array.isArray(item))
export const isBoolean = (bool) => bool === true || bool === false
// Also allow space and dash
export const isAlphanumericIsh = (string) => /^[a-z0-9 -]+$/i.test(string)
// Simple, based on known exceptions
export const isDutchPostalcode = (string) => /^[1-9][0-9]{3} ?(?!SA|SD|SS)[A-Z]{2}$/i.test(string)
// https://rgxdb.com/r/316F0I2N //
export const isBelgianPostalcode = (string) => /^(?:(?:[1-9])(?:\d{3}))$/.test(string)
export const isBritishPostalCode = (string) => /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/.test(string)
export const isValidPostalcode = (string, funcArr, isBritish) => {
  return vlaanderen  || string.length === 4  // Not VLA (e.g. evtools) Belgian postalCode temp. fix //
    ? isBelgianPostalcode(string)
    : isBritish
      ? isBritishPostalCode(string)
      : isDutchPostalcode(string)
}

// Simple, based on generic number plate structure
export const isDutchNumberplate = (string) => /^([a-z]{1,3}|[\d]{1,3})-?([a-z]{1,3}|[\d]{1,3})-?([a-z]{1,3}|[\d]{1,3})$/i.test(string)
// https://regexr.com/3aevr - slightly modified
export const isDutchPhoneNumber = (string) => /^((\+|00(\s|\s?-\s?)?)31(\s|\s?-\s?)?(\(0\)[-\s]?)?|0)[1-9]((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(string)
// https://emailregex.com - slightly modified
export const isEmail = (string) => /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x21\x23-\x5b\x5d-\x7f]|\\[\x5d-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x21-\x5a\x53-\x7f]|\\[\x5d-\x7f])+)\])/.test(string)
// https://dev.to/calvinpak/simple-url-validation-with-javascript-4oj5 - no IE support
export const isUrl = (url) => { try { new URL(url) } catch (e) { return false } return true }

export const isLatitude = (string) => parseFloat(string) <= 90 && parseFloat(string) >= -90
export const isLongitude = (string) => parseFloat(string) <= 180 && parseFloat(string) >= -180

export const unicodeString = (string) => /^([\u00c0-\u01ffa-zA-Z0-9'\-,._@€+!?&:;()#/" ])+$/.test(string)
export const multilineUnicodeString = (string) => /^([\u00c0-\u01ffa-zA-Z0-9'\-,._@€+!?&:;()#/" \r\n])+$/.test(string)

export const getInvalidCharacters = (string) =>  {
  const str = Array.isArray(string) ? string.join() : string || ''
  const uniques = new Set(str.replace(/[\u00c0-\u01ffa-zA-Z0-9'\-,._@€+!?&:;()#/" ]/g, '').split(''))

  return [...uniques].join('')
}

/**
 * Alphanumeric + underscore
 */
export const isAplhanumericUnderscore = (string) => /^[a-z0-9_]+$/i.test(string)
export const isValidLatitude = (lat) => /^(\+|-)?(?:90(?:(?:\.0{1,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,16})?))$/.test(lat)
export const isValidLongitude = (lng) => /^(\+|-)?(?:180(?:(?:\.0{1,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,16})?))$/.test(lng)

export const isPositive = (value) => parseFloat(value) > 0

export const isValidEAN = (string) => /^\d{18}$/.test(string)
export const isValidQRCode = (string) => /^\d{6}$/.test(string)

/**
 * QR = [thousands digit][2-digit region][3-digit serial], e.g. 142000 → 1 | 42 | 000
 * EVSE = prefix + '0' + region + 5-digit serial (thousands digit + 3-digit serial, zero padded)
 *  e.g. with prefix BE*VIA*E20:
 *   QR 042999 → BE*VIA*E2004200999
 *   QR 142000 → BE*VIA*E2004201000
 * Only defined up to serial 9999 (QR 9xx999); the format beyond that is not specified yet
 */
export const deriveEvse = (qr, prefix) => {
  if (!isValidQRCode(qr)) return null
  return prefix + '0' + qr.slice(1, 3) + '0' + qr.slice(0, 1) + qr.slice(3)
}
export const deriveEvseId = (qr, prefix) => {
  const evse = deriveEvse(qr, prefix)
  return evse && evse + '*1'
}
export const deriveEvseId2 = (qr, prefix) => {
  const evse = deriveEvse(qr, prefix)
  return evse && evse + '*2'
}


/**
 * Auth0 ids
 *  For now just accept a-z0-9|
 */
export const isAuthZeroId = (string) => /^[a-z0-9|]+$/i.test(string)

export const isValue = (value) => {
  if (Array.isArray(value)) return !!value.length
  if (value === undefined || value === null) {
    return false
  }

  if (value === false) {
    return true
  }

  if (value instanceof Date) {
    // invalid date won't pass
    return !isNaN(value.getTime())
  }

  if (typeof value === 'object') {
    for (let _ in value) return true
    return false
  }

  return !!String(value).length
}

export const required = (value) => {
  if (typeof value === 'string') {
    return isValue(value.trim())
  }
  return isValue(value)
}
